var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('section',{staticClass:"course_status",class:{
    'scale-mobile': _vm.isMobile,
  },style:(_vm.stylesheet),attrs:{"is-example":_vm.isExample}},[_c('section',{staticClass:"course_status__content",attrs:{"has_access":_vm.hasAccess}},[_c('span',[_vm._v(_vm._s(_vm.hasAccess ? _vm.$t("home2.course_template.available") : _vm.$t("home2.course_template.not_available")))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }